export const getUserProjectName = ({ project, account }: { project: string; account: string | null }): string =>
  account ? `${account}: ${project}` : project;
